import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Button,
  Image,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  useDisclosure,
  Skeleton,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import useDebounce from "../../hooks/useDebounce";
import ReactPaginate from "react-paginate";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import iconEdit from "../../assets/images/product/edit.svg";
import icontrash from "../../assets/images/product/trash.svg";
import { AiOutlineMore } from "react-icons/ai";
import DeleteDialog from "../../components/dialog/delete";
import DatePicker from "react-datepicker";
import { useBrokerDebtDisbursement } from "../../hooks/useBrokerDebtDisbursement";
import { useCategories } from "../../categorys/brokerDebtDisbursement/index";
import toast from "react-hot-toast";
import { brokerDebtDisbursementCall } from "../../api/brokerDebtDisbursement";
import AddBrokerDebtDisbursement from "./form/addBrokerDebtDisbursement";
import SearchableSelect from "../../components/selectForm";
import FormInfoEmployee from "../../components/form/formInfo";
import { employeeCall } from "../../api/employee";
import { brokerDebtCertificateCall } from "../../api/brokerDebtCertificate";
import ColumnFilterRow from "../../components/table/columnFilterRow";

const TableApartments = ({ isRefetchingWithCreate }) => {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const {
    isOpen: isOpenEmployee,
    onOpen: onOpenEmployee,
    onClose: onCloseEmployee,
  } = useDisclosure();
  const {
    isOpen: isOpenBrokerDebtDisbursement,
    onOpen: onOpenBrokerDebtDisbursement,
    onClose: onCloseBrokerDebtDisbursement,
    onToggle: onToggleBrokerDebtDisbursement,
  } = useDisclosure();
  const {
    isOpen: isOpenDisbursement,
    onOpen: onOpenDisbursement,
    onClose: onCloseDisbursement,
  } = useDisclosure();
  // table
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  // const [search, setSearch] = useState("");
  const [dataEdit, setDataEdit] = useState(null);
  const [popupDelete, setPopupDelete] = useState(false);
  const [employeeId, setEmployeeId] = useState(null);
  const [shouldFetch, setShouldFetch] = useState(false);

  const {
    brokerDebtDisbursementData,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useBrokerDebtDisbursement("", employeeId, startDate, endDate);

  // refech create
  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }
  const prevIsRefetchingWithCreate = usePrevious(isRefetchingWithCreate);

  useEffect(() => {
    if (
      isRefetchingWithCreate &&
      prevIsRefetchingWithCreate !== isRefetchingWithCreate
    ) {
      refetch();
    }
  }, [isRefetchingWithCreate, prevIsRefetchingWithCreate, refetch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const { constantData } = useCategories(shouldFetch);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({ key, value }));

  const employees = useMemo(
    () => formatEntries(constantData?.employee),
    [constantData?.employee]
  );

  const tableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "Mã NV",
        key: "codeEmployee",
      },
      {
        label: "Tên NV",
        key: "nameEmployee",
      },
      {
        label: "Số tiền thanh toán",
        key: "disbursedAmount",
      },
      {
        label: "Số tiền tạm giữ hiện tại",
        key: "amountHeld",
      },
      {
        label: "Số tiền đã trả hiện tại",
        key: "amountPaid",
      },
      {
        label: "Thời gian tạo",
        key: "createdAt",
      },
    ],
    data: brokerDebtDisbursementData,
  };

  const handlePageChange = (selectedPage) => {
    setPopupDelete(false);
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  const handlePopupDelete = (e) => {
    setDataEdit(e?.edit);
    setPopupDelete(true);
    onOpen();
  };

  const handlePopup = (type, e) => {
    setPopupDelete(false);
    setDataEdit(e?.edit);
    onOpen();
  };

  const handlePopupEmployee = (e) => {
    setDataEdit(e);
    onOpenEmployee();
  };

  const onSubmitEdit = async (data) => {
    const toastCreate = toast.loading(
      "Đang sửa công nợ chứng chỉ môi giới ..."
    );
    try {
      const { id, ...dataEdit } = data;
      await brokerDebtDisbursementCall.update(id, dataEdit);

      await refetch();
      onToggle();
      onClose();
      toast.success("Sửa thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const onSubmitDelete = async () => {
    const toastEdit = toast.loading("Đang xóa dữ liệu ...");
    try {
      const { id } = dataEdit;
      await brokerDebtDisbursementCall.delete(id);
      await refetch();
      setDataEdit(null);
      onClose();
      toast.success("Xóa thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi xóa");
    }
    toast.dismiss(toastEdit);
  };

  const onSubmitBrokerDebtDisbursement = async (data) => {
    const toastCreate = toast.loading("Đang tạo thanh toán...");
    try {
      await brokerDebtDisbursementCall.create(data);

      await refetch();
      onToggleBrokerDebtDisbursement();
      onCloseBrokerDebtDisbursement();
      toast.success("Tạo thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const handleDisbursementEmployee = async (id) => {
    const toastUpdate = toast.loading(
      "Đang cập nhật trạng thái sở hữu chúng chỉ môi giới ..."
    );
    try {
      await employeeCall.disbursement(id);
      await refetch();
      toast.success("Cập nhật thành công");
      setDataEdit(null);
      onCloseDisbursement();
    } catch (error) {
      console.log({ error });
    }
    toast.dismiss(toastUpdate);
  };

  const handleCloseDisbursement = () => {
    setDataEdit(null);
    onCloseDisbursement();
  };

  const handleOpenDisbursement = (e) => {
    console.log(e);
    setDataEdit(e);
    onOpenDisbursement();
  };

  // Bộ lọc chuyển lên hàng dưới tiêu đề cột — tái dùng state/setter sẵn có,
  // không đổi logic lọc, chỉ đổi vị trí control.
  const columnFilters = {
    nameEmployee: (
      <SearchableSelect
        isShowSearch={true}
        options={employees}
        initialSelectedOption={{ key: 0, value: "Tất cả" }}
        setValue={setEmployeeId}
        selectedKey={employeeId}
        width="100%"
        minW="200px"
      />
    ),
    createdAt: (
      <InputGroup w={"100%"} minW={"230px"} maxW={"260px"}>
        <DatePicker
          selectsRange={true}
          startDate={startDate}
          endDate={endDate}
          dateFormat="dd/MM/yyyy"
          locale="vi"
          onChange={(update) => {
            setDateRange(update);
          }}
          isClearable={true}
          placeholderText="Từ ngày - đến ngày"
          className="datePickerStyle"
          popperProps={{ strategy: "fixed" }}
          portalId="datepicker-portal"
        />
        {!startDate && !endDate && (
          <InputRightElement pointerEvents="none" h={"44px"}>
            <Image src={calendarIcon} />
          </InputRightElement>
        )}
      </InputGroup>
    ),
  };

  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Box width={"100%"} height={"100%"}>
            {/* Header + hàng bộ lọc luôn hiển thị; chỉ hiện Skeleton ở vùng dữ liệu khi tải/refetch */}
            <>
              <TableContainer
                w={"100%"}
                maxH="calc(100vh - 350.5px)"
                overflowY="auto"
              >
                <Table w={"100%"} variant="unstyled">
                  <Thead
                    position="sticky"
                    top="0"
                    zIndex="1"
                    w={"100%"}
                    h={"41px"}
                    color="white"
                    fontWeight="400"
                    backgroundColor="#F9FAFD"
                  >
                    <Tr h={{ base: "41px" }}>
                      {tableData.headers.map((e, index) => {
                        let width = "auto";
                        let textAlign = "auto";
                        if (e.key === "") {
                          width = "2%";
                          textAlign = "center";
                        } else if (e.key === "codeEmployee") {
                          width = "5%";
                          textAlign = "start";
                        } else if (e.key === "nameEmployee") {
                          width = "20%";
                          textAlign = "start";
                        } else if (e.key === "disbursedAmount") {
                          width = "15%";
                          textAlign = "start";
                        } else if (e.key === "amountHeld") {
                          width = "15%";
                          textAlign = "start";
                        } else {
                          width = "20%";
                          textAlign = "end";
                        }
                        return (
                          <Td
                            p={"16px 16px 8px 16px"}
                            key={index}
                            border={"none"}
                            color={"#51607B"}
                            fontSize={{ base: "14px" }}
                            w={width}
                          >
                            <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                          </Td>
                        );
                      })}
                    </Tr>
                    <ColumnFilterRow
                      headers={tableData.headers}
                      filters={columnFilters}
                      backgroundColor="#F9FAFD"
                    />
                  </Thead>
                  <Tbody w={"100%"} h={"100%"}>
                    {isLoading || isRefetching ? (
                      <Tr>
                        <Td colSpan={tableData.headers.length} p={"16px"}>
                          <Skeleton height="400px" borderRadius="8px" />
                        </Td>
                      </Tr>
                    ) : tableData.data?.length > 0 ? (
                      tableData.data?.map((e, rowIndex) => {
                        const items = { ...e };
                        delete items.id;
                        delete items.edit;
                        delete items.detail;
                        delete items.employeeId;
                        delete items.isBrokerDebtDisbursement;
                        const keyValues = Object.keys(items);
                        return (
                          <Tr key={rowIndex} h={"72px"}>
                            <Td p={"16px 16px 8px 16px"} w={"2%"}>
                              <Menu>
                                <MenuButton
                                  _hover={{ backgroundColor: "none" }}
                                  _active={{ backgroundColor: "none" }}
                                  background="none"
                                  as={Button}
                                >
                                  <AiOutlineMore fontSize={"20px"} />
                                </MenuButton>
                                <MenuList
                                  fontSize={{ base: "14px" }}
                                  fontWeight={500}
                                  lineHeight={"140%"}
                                  color={"var(--color-info-employee)"}
                                >
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(true, e)}
                                  >
                                    <Image src={iconEdit} /> Chỉnh sửa
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopupDelete(e)}
                                  >
                                    <Image src={icontrash} /> Xóa bản ghi
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Td>
                            {keyValues.map((keyvalue, index) => {
                              let width = "auto";
                              let widthText = "100%";
                              let textAlign = "auto";
                              let whiteSpace = "inherit";
                              if (keyvalue === "") {
                                width = "2%";
                                textAlign = "center";
                              } else if (keyvalue === "codeEmployee") {
                                width = "5%";
                                textAlign = "start";
                              } else if (keyvalue === "nameEmployee") {
                                width = "20%";
                                textAlign = "start";
                              } else if (keyvalue === "disbursedAmount") {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "amountHeld") {
                                width = "15%";
                                textAlign = "start";
                              } else {
                                width = "20%";
                                textAlign = "end";
                                whiteSpace = "inherit";
                              }
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  w={width}
                                  key={index}
                                >
                                  <Box
                                    fontSize={{ base: "14px" }}
                                    lineHeight={"19.6px"}
                                    textAlign={"start"}
                                    fontWeight={500}
                                    color={"var(--color-info-employee)"}
                                    w={widthText}
                                    whiteSpace={whiteSpace}
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    display="-webkit-box"
                                    sx={{
                                      WebkitLineClamp: "2",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {keyvalue === "codeEmployee" ||
                                    keyvalue === "nameEmployee"
                                      ? formatTableValue(
                                          e[keyvalue],
                                          keyvalue,
                                          handlePopupEmployee,
                                          e
                                        )
                                      : formatTableValue(e[keyvalue], keyvalue)}
                                  </Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td
                          colSpan={tableData.headers.length}
                          textAlign="center"
                          padding={"40px 0"}
                        >
                          Không có dữ liệu
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </>
            <Box mt={10} mr={5} mb={5} ml={5}>
              <Flex alignItems={"center"} justifyContent={"space-between"}>
                <Text>
                  Showing {startEntry} to {endEntry} of {entries} entries
                </Text>
                <HStack spacing={2} justify="flex-end">
                  <ReactPaginate
                    className="pagination-custom"
                    pageCount={totalPages}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    breakClassName={"ellipsis"}
                    breakLabel={"..."}
                    previousLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronLeft}
                      />
                    }
                    nextLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronRight}
                      />
                    }
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                  />
                </HStack>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Flex>
      {!popupDelete ? (
        <AddBrokerDebtDisbursement
          isOpen={isOpen}
          onClose={onClose}
          isEdit={true}
          defaultValues={dataEdit}
          onSubmit={onSubmitEdit}
        />
      ) : (
        <DeleteDialog
          isOpen={isOpen}
          onClose={onClose}
          title="Xóa bản ghi thanh toán"
          description={
            <Flex display={"inline"}>
              "Bạn có chắc chắn muốn xóa dữ liệu của nhân viên{" "}
              <Text fontWeight={"600"} display={"inline"}>
                {dataEdit?.name}
              </Text>{" "}
              không?"
            </Flex>
          }
          action={() => onSubmitDelete()}
        />
      )}
      <FormInfoEmployee
        isOpen={isOpenEmployee}
        onClose={onCloseEmployee}
        defaultValues={[]}
        idData={dataEdit?.employeeId}
      />
      <DeleteDialog
        isOpen={isOpenDisbursement}
        onClose={handleCloseDisbursement}
        title={"Xóa dữ liệu thanh toán"}
        description={`Bạn có xóa dữ liệu thanh toán của nhân viên ${dataEdit?.nameEmployee} không ?`}
        action={() => handleDisbursementEmployee(dataEdit?.employeeId)}
        textDelete={"Xác nhận"}
      />
    </>
  );
};

export default TableApartments;
